import handleError from "../helpers/handleError";
import useUpdateCombatant from "./useUpdateCombatant";
//----------------------------
// update multiple combatants
//----------------------------
export default async function useUpdateMultipleCombatants(combatants) {
  console.log("----------------------------------");
  console.log("IN useUpdateMultipleCombatants...");
  //-----------------------
  // for storing responses
  //-----------------------
  let responses = [];
  //-----------------
  // loop combatants
  //-----------------
  for (let i = 0; i < combatants.length; i++) {
    //------------------
    // update combatant
    //------------------
    let api_call = useUpdateCombatant(combatants[i]);
    await api_call
      .then((response_parms) => {
        responses.push(response_parms);
      })
      .catch((err) => {
        handleError(err, 40);
      });
  }
  //----------------------
  // return all responses
  //----------------------
  return responses;
}
